import { render, staticRenderFns } from "./FormPagosCorreccion.vue?vue&type=template&id=19665685&"
import script from "./FormPagosCorreccion.vue?vue&type=script&lang=js&"
export * from "./FormPagosCorreccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports